import { format as formatDateFns, isValid, parse, parseISO } from 'date-fns'
import { de, enUS, es, fr, it, ja, ptBR } from 'date-fns/locale'

const locales = { de, en: enUS, es, fr, it, ja, pt: ptBR }
const localizedFormats = {
  LT: 'p', LTS: 'pp', l: 'P', L: 'P', ll: 'PP', LL: 'PPPP',
  lll: 'PPp', LLL: 'PPp', llll: 'PPp', LLLL: 'PPPPp'
}
const legacyTokens = /\[[^\]]*]|YYYY|YY|dddd|ddd|dd|MMMM|MMM|MM|M|Do|DD|D|HH|H|hh|h|mm|m|ss|s|ZZ|Z|A|a|T/g

export const getDateFnsLocale = (locale) => {
  const language = (locale || 'en').toLowerCase().split('-')[0]
  return locales[language] || enUS
}

export const getWeekStartsOn = (locale, firstDayOfWeek) => {
  if (Number.isInteger(firstDayOfWeek)) return Math.min(6, Math.max(0, firstDayOfWeek))
  return getDateFnsLocale(locale).options.weekStartsOn || 0
}

export const toDateFnsFormat = (format) => {
  if (!format) return format
  if (localizedFormats[format]) return localizedFormats[format]
  return format.replace(legacyTokens, token => {
    if (token[0] === '[') return `'${token.slice(1, -1)}'`
    return {
      YYYY: 'yyyy', YY: 'yy', dddd: 'EEEE', ddd: 'EEE', dd: 'EE', Do: 'do',
      DD: 'dd', D: 'd', ZZ: 'xx', Z: 'xxx', A: 'a', T: "'T'"
    }[token] || token
  })
}

export const parseDateValue = (value, inputFormat, locale) => {
  if (value === null || typeof value === 'undefined' || value === '') return null
  if (value instanceof Date) return isValid(value) ? new Date(value.getTime()) : null
  if (typeof value === 'number') {
    const date = new Date(value)
    return isValid(date) ? date : null
  }

  const text = String(value)
  if (inputFormat) {
    try {
      const date = parse(text, toDateFnsFormat(inputFormat), new Date(), { locale: getDateFnsLocale(locale) })
      if (isValid(date)) return date
    } catch (e) {}
  }
  try {
    const date = parseISO(text)
    if (isValid(date)) return date
  } catch (e) {}
  const date = new Date(text)
  return isValid(date) ? date : null
}

export const formatDateValue = (value, format, locale, inputFormat = format) => {
  const date = parseDateValue(value, inputFormat, locale)
  if (!date || !format) return ''
  try {
    const result = formatDateFns(date, toDateFnsFormat(format), { locale: getDateFnsLocale(locale) })
    return format.includes('a') && !format.includes('A') ? result.replace(/\b(AM|PM)\b/g, value => value.toLowerCase()) : result
  } catch (e) {
    return ''
  }
}

export const getDefaultLocale = () => {
  if (typeof window === 'undefined') return null

  const { userLanguage, language } = window.navigator
  return (userLanguage || language || 'en').substr(0, 2)
}
